import { StyledModal } from '@app/components/modal/Modal';
import useTextAgentActions from '@app/hooks/text-agents/useTextAgentActions';
import { TextAgentForm } from './TextAgentForm';
import type { AITextAgent } from '@app/services/text-agent.types';
import type { ModalProps } from 'antd';

export type TextAgentAddModalProps = ModalProps & {
    title?: string;
    data?: AITextAgent;
};

export const TextAgentAddModal = ({
    title = 'Add AI Text Agent',
    data,
    onOk,
    ...props
}: TextAgentAddModalProps) => {
    const { addTextAgent } = useTextAgentActions();

    // Reset the component if closed
    if (!props.open) {
        return null;
    }

    return (
        <StyledModal title={title} footer={null} width={680} {...props}>
            <TextAgentForm
                id="ai-text-agent-add"
                data={data}
                onCancel={props.onCancel}
                loading={addTextAgent.isPending}
                onSubmit={(values) => {
                    const formData = {
                        ...values,
                    };
                    addTextAgent.mutate(formData, {
                        onSuccess: () => {
                            if (onOk) {
                                onOk(undefined as unknown as React.MouseEvent<HTMLButtonElement>);
                            }
                        },
                    });
                }}
            />
        </StyledModal>
    );
};
